import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

export default function PaginationInquiryList(props) {
    const {
        coupon
    } = props

    const dataList = coupon || [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const [page, setPage] = useState(1);
    
    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);

    const [view, setView] = useState(Array(Items.length).fill(false))

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };  

    const ViewToggle = (index) => {
        setView((prevView) => 
            prevView.map((v, i) => (i === index ? !v : v))
        );
    };



    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box inquiry">
                <div className="list_title">
                    <p>분류</p>
                    <p className="inqu_title">내용</p>
                    <p>문의 일자</p>
                    <p>답변 상태</p>
                </div>

                {dataList.length === 0 ?
                    <p className="not_coupon">문의 내역이 없습니다.</p>
                    :
                    <>
                        {Items.map((x, i) => (
                            <>
                                <div key={i} className={`my_coupon_info`}>
                                    <p>프로그램 오류</p>
                                    <div 
                                        className="inqu_box"
                                        onClick={() => {
                                            ViewToggle(i)
                                        }}
                                    >
                                        <p className={`title ${view[i] ? 'on' : ''}`}>문의내용 20자</p>
                                    </div>
                                    <p>2024-10-07</p>
                                    <p className="inqu_status">
                                        <span>
                                            미답변
                                        </span>
                                    </p>
                                </div>

                                {view[i] &&
                                    <div key={i} className="inquiry_content">
                                        <div className="text">
                                            문의하기 내용입니다.문의하기 내용입니다.문의하기 내용입니다.문의하기 내용입니다.문의하기 내용입니다.문의하기 내용입니다.문의하기 내용입니다.
                                        </div>

                                        <div className="comment">
                                            <img src={require("../assets/icon/inquiry_arr.svg").default}/>

                                            <div>
                                                <div className="title">
                                                    <p>답변</p>
                                                    <span>2024.05.01</span>
                                                </div>

                                                <div className="content">
                                                    문의답변 내용입니다.문의답변 내용입니다.문의답변 내용입니다.문의답변 내용입니다.문의답변 내용입니다.문의답변 내용입니다.문의답변 내용입니다.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                
                            </>
                        ))}
                    </>
                }            
            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={8}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default}/>}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default}/>}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default}/>}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default}/>}
            ></Pagination>
        </div>
    )
}